<template>
  <div id="app" class="vg-background">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>

import useAuthnStore from "@/store/authn";

export default {
  data() {
    return {
      visibilitychangeListener: false
    }
  },
  mounted() {
    if (this.visibilitychangeListener) {
      return
    }

    this.visibilitychangeListener = true

    document.addEventListener("visibilitychange", () => {
      if (useAuthnStore().isLatestLoginManagement) {
        this.$router.go(0)
      }
    })
  }
}

</script>

<style>
@import "App.css";

.vg-background {
  background: #F6F6F6;
  overflow: hidden;
  min-height: 100vh;
  min-height: 100dvh;
  /*min-height: calc(100vh - var(--vh-offset, 0px));*/
}
</style>
